<p-overlayPanel
  #op
  [styleClass]="styleClass() + (paddingless ? 'overlaypanel-paddingless' : '')"
  [dismissable]="dismissable"
  (onShow)="this.onShow.emit()"
  (onHide)="this.onHide.emit()"
  [appendTo]="this.appendTo"
>
  <div [ngClass]="wrapperClass ? wrapperClass : 'overlay-wrapper'">
    @if (showHeader) {
      <div class="overlay-header">
        <ng-content select="[header]"></ng-content>
      </div>
    }
    <div class="overlay-content">
      <div class="overlay-content-inner-wrapper">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>
    @if (showFooter) {
      <div class="overlay-footer">
        <ng-content select="[footer]"></ng-content>
      </div>
    }
  </div>
</p-overlayPanel>
